import { SkinAnalysisSectionIdentifier } from '../../Types';

// also see:  GesagtGetan.TypeScript\Resources\Private\Fusion\Components\Types.ts

export const getSectionLabel = (skinAnalysisSectionIdentifier: SkinAnalysisSectionIdentifier): string => {
    return sectionLabels.get(skinAnalysisSectionIdentifier) || '';
};

export const getSectionIDs = (): SkinAnalysisSectionIdentifier[] => {
    return Array.from(sectionLabels.keys());
};

export const sectionLabels: Map<SkinAnalysisSectionIdentifier, string> = new Map([
    ['Face', 'Gesicht'],
    // ['Eyes', 'Augen'],
    // ['Lips', 'Lippen'],
    // ['Neck', 'Hals & Dekolleté'],
    // ['Body', 'Körper'],
    // ['Hands', 'Hände'],
    // ['Feet', 'Füße']
]);
